import { _ as $ } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.array.concat-d1c9b847.js";
import "./es.array.find-index-cbf7640b.js";
import "./web.dom-collections.for-each-3020ed11.js";
import "./es.array.splice-801adf1d.js";
import "./es.object.assign-7e79fd7b.js";
import "./es.object.to-string-f55666a8.js";
import { zIndices as D } from "@ucl/shared-component-foundations";
import W, { useRef as L, useEffect as w, useState as A, useCallback as H } from "react";
import "./es.array.map-d821aaf5.js";
import { c as I } from "./index-8b07dec9.js";
import { createPortal as G } from "react-dom";
import "./es.object.keys-9d66766f.js";
import { usePopoverIndex as U } from "./usePopoverIndex.js";
import "./es.array.filter-4e9c9996.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.object.entries-d2a19275.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.array.is-array-7a29277f.js";
import { g as Z } from "./getMetrics-953aa4f8.js";
import "./web.set-timeout-72b6430f.js";
import "./es.array.some-0c761b6d.js";
import "./es.array.every-3d11adb5.js";
import "./useScroll.js";
import "./useSlots.js";
import "./createClass-57dcdeea.js";
import "./es.date.to-json-b76d522e.js";
import "./es.date.to-string-6ed49878.js";
import "./es.regexp.to-string-e800d529.js";
import { useTimeout as E } from "./useTimeout.js";
import { a as J } from "./index-5d0f31c6.js";
import { CloseButton as K } from "./closeButton.js";
import y, { css as h } from "styled-components";
import { Button as Q } from "./button.js";
import { jsx as p, jsxs as q } from "react/jsx-runtime";
import "./export-cdcbfb2b.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./object-keys-719a5561.js";
import "./html-32ef1b46.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./array-iteration-759bfbfa.js";
import "./array-method-is-strict-e5a3c878.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-apply-4756dee6.js";
import "./environment-ddee5959.js";
import "./array-slice-79f93c56.js";
import "./validate-arguments-length-eb516e5b.js";
import "./getTarget-19e0f923.js";
import "./useEventListener.js";
import "./isClient-2f5bedbd.js";
import "./useOverFlown.js";
import "./useResizeObserver.js";
import "./isApiSupported-66660265.js";
import "./useIsMounted.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
import "./an-instance-6efcfd6c.js";
import "./check-correctness-of-iteration-7d57c70c.js";
import "./inherit-if-required-f068457b.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./set-species-5ede2ed0.js";
import "./es.string.iterator-5de8a61e.js";
import "@ucl/shared-icons";
import "./aria.js";
import "./iconButton.js";
import "./combineRefs-c9ad2c39.js";
var X = /* @__PURE__ */ y.div.withConfig({
  displayName: "snackbarstyles__Container",
  componentId: "tk8o0z-0"
})(["&.SnackbarContainer{", ";}"], function(r) {
  var n = r.theme.components.snackbar;
  return h(n.Container);
}), Y = /* @__PURE__ */ y.div.withConfig({
  displayName: "snackbarstyles__SnackbarWrapper",
  componentId: "tk8o0z-1"
})(["&.Snackbar-wrapper{", ";}"], function(r) {
  var n = r.theme.components.snackbar;
  return h(n.SnackbarWrapper);
}), nn = /* @__PURE__ */ y.div.withConfig({
  displayName: "snackbarstyles__Snackbar",
  componentId: "tk8o0z-2"
})(["&.Snackbar{", ";}"], function(r) {
  var n = r.theme.components.snackbar;
  return h(n.Snackbar);
}), rn = /* @__PURE__ */ y.div.withConfig({
  displayName: "snackbarstyles__Content",
  componentId: "tk8o0z-3"
})(["&.Snackbar__content{", ";}"], function(r) {
  var n = r.theme.components.snackbar;
  return h(n.Content);
}), an = /* @__PURE__ */ y.p.withConfig({
  displayName: "snackbarstyles__Body",
  componentId: "tk8o0z-4"
})(["&.Snackbar__content-body{", ";}"], function(r) {
  var n = r.theme.components.snackbar;
  return h(n.Body);
}), tn = /* @__PURE__ */ y(Q).withConfig({
  displayName: "snackbarstyles__SnackbarButton",
  componentId: "tk8o0z-5"
})(["&.Snackbar__button{", ";}"], function(r) {
  var n = r.theme.components.snackbar;
  return h(n.Button);
}), on = ["id", "type", "icon", "message", "buttonText", "dismissible", "onButtonClick", "buttonProps", "closeButtonProps", "autoCloseTime", "stopAutoCloseOnHover", "className"], en = 300, sn = function(n) {
  var k = n.id, b = n.type, c = b === void 0 ? "primary" : b, l = n.icon, v = n.message, S = n.buttonText, B = n.dismissible, x = n.onButtonClick, o = n.buttonProps, t = n.closeButtonProps, N = n.autoCloseTime, f = N === void 0 ? 3e3 : N, g = n.stopAutoCloseOnHover, T = n.className, O = $(n, on), d = L(null), u = c === "error", _ = pn(), R = _.removeSnackBar;
  w(function() {
    var i;
    return (i = d.current) == null || i.scrollIntoView == null ? void 0 : i.scrollIntoView();
  }, []);
  var z = A(!1), j = z[0], a = z[1], m = function() {
    return a(!0);
  }, e = E(m, f > 0 ? f : null), s = e.startTimeout, P = e.clearTimeout, M = function() {
    R(k), a(!1);
  };
  return E(M, j ? en : null), /* @__PURE__ */ p(Y, {
    className: I(["Snackbar-wrapper", "Snackbar-wrapper--" + c, {
      "Snackbar-wrapper--fadeOut": j
    }, T]),
    children: /* @__PURE__ */ q(nn, Object.assign({
      ref: d,
      className: I(["Snackbar", "Snackbar--" + c]),
      role: "alert",
      id: k == null ? void 0 : k.toString(),
      onMouseOver: function() {
        return g ? P() : null;
      },
      onMouseLeave: function() {
        return f > 0 ? s() : null;
      }
    }, O, {
      children: [/* @__PURE__ */ p(J, {
        className: "Snackbar__Icon",
        icon: l,
        size: "m"
      }), /* @__PURE__ */ p(rn, {
        className: "Snackbar__content",
        children: /* @__PURE__ */ p(an, {
          className: "Snackbar__content-body",
          children: v
        })
      }), (S || (o == null ? void 0 : o.children)) && /* @__PURE__ */ p(tn, Object.assign({
        onClick: x
      }, o, {
        size: "small",
        variant: u ? "secondary" : "primary",
        color: u ? "onColor" : "default",
        className: I(["Snackbar__button", "Snackbar__button--" + c, o == null ? void 0 : o.className]),
        children: (o == null ? void 0 : o.children) || S
      })), B && /* @__PURE__ */ p(K, Object.assign({}, t, {
        surface: "dark",
        size: "small",
        className: I(["Snackbar__close-button", t == null ? void 0 : t.className]),
        onClick: function(C) {
          m(), t == null || t.onClick == null || t.onClick(C);
        }
      }))]
    }))
  });
}, cn = ["type", "style", "className", "snackbars", "zIndex"], ln = function(n) {
  var k = n.type, b = n.style, c = n.className, l = n.snackbars, v = n.zIndex, S = $(n, cn), B = Z({
    label: "Snackbar"
  }), x = U(l.length > 0, v);
  return l.length === 0 ? null : /* @__PURE__ */ G(/* @__PURE__ */ p(X, Object.assign({
    className: I(["SnackbarContainer", "SnackbarContainer--" + k, c]),
    style: Object.assign({
      zIndex: x
    }, b)
  }, B, S, {
    children: l.map(function(o) {
      return /* @__PURE__ */ p(sn, Object.assign({}, o), o.id);
    })
  })), document.body);
}, un = ["type", "maximum", "zIndex", "children"], mn = ["id"], F = /* @__PURE__ */ W.createContext({
  setMaximumSnackbars: function() {
    return null;
  },
  setSnackbarsType: function() {
    return null;
  },
  addSnackBar: function() {
    return null;
  },
  removeSnackBar: function() {
    return null;
  },
  removeAllSnackBars: function() {
    return null;
  },
  snackbarIdRef: {
    current: 0
  }
}), jr = function(n) {
  var k = n.type, b = k === void 0 ? "queue" : k, c = n.maximum, l = c === void 0 ? 0 : c, v = n.zIndex, S = v === void 0 ? D.toast : v, B = n.children, x = $(n, un), o = A(b), t = o[0], N = o[1], f = A(l), g = f[0], T = f[1], O = A([]), d = O[0], u = O[1], _ = L(0);
  w(function() {
    return N(b);
  }, [b]), w(function() {
    return T(l);
  }, [l]), w(function() {
    g <= 0 || d.length <= g || u(t === "stack" ? function(a) {
      return a.pop(), [].concat(a);
    } : function(a) {
      return a.shift(), [].concat(a);
    });
  }, [d.length, g, t]);
  var R = H(function(a) {
    var m = a.id, e = $(a, mn);
    u(t === "stack" ? function(s) {
      return [Object.assign({}, e, {
        id: m ?? _.current++
      })].concat(s);
    } : function(s) {
      return [].concat(s, [Object.assign({}, e, {
        id: m ?? _.current++
      })]);
    });
  }, [t]), z = H(function(a) {
    u(function(m) {
      var e = [].concat(m);
      if (a !== void 0) {
        var s = e.findIndex(function(V) {
          return V.id === a;
        });
        if (s >= 0) {
          var P, M;
          (P = (M = e[s]).onClose) == null || P.call(M, e[s]), e.splice(s, 1);
        }
      } else if (t === "stack") {
        var i = e.pop();
        i == null || i.onClose == null || i.onClose(i);
      } else {
        var C = e.shift();
        C == null || C.onClose == null || C.onClose(C);
      }
      return e;
    });
  }, [t]), j = H(function() {
    d.forEach(function(a) {
      return a.onClose == null ? void 0 : a.onClose(a);
    }), u(function() {
      return [];
    });
  }, [d]);
  return /* @__PURE__ */ q(F.Provider, {
    value: {
      setSnackbarsType: N,
      setMaximumSnackbars: T,
      addSnackBar: R,
      removeSnackBar: z,
      removeAllSnackBars: j,
      snackbarIdRef: _
    },
    children: [/* @__PURE__ */ p(ln, Object.assign({
      type: t,
      snackbars: d,
      zIndex: S
    }, x)), B]
  });
}, pn = function() {
  return W.useContext(F);
};
export {
  jr as SnackbarProvider,
  pn as useSnackbars
};
